import { useCallback } from 'react';
import { useSearchParams } from 'react-router';
import { atom, useRecoilValue, useSetRecoilState } from 'recoil';
import { useScheduledBroadcast } from './scheduleState';
export const streamState = atom({
    key: 'streamState',
    default: {},
});
export function useStreamDirection(streamId) {
    const directions = useRecoilValue(streamState) || {};
    const mode = useSearchParams()[0].get('mode');
    const broadcast = useScheduledBroadcast(streamId);
    if (!streamId) {
        return undefined;
    }
    if (mode === 'viewer') {
        return 'incoming';
    }
    if (mode === 'broadcaster' || broadcast) {
        return 'outgoing';
    }
    return directions[streamId];
}
export function useSetStreamDirectionCallback() {
    const setStreamDirection = useSetRecoilState(streamState);
    return useCallback((streamId, value) => {
        if (value) {
            setStreamDirection((directions) => ({
                ...directions,
                [streamId]: value,
            }));
            return;
        }
        setStreamDirection(({ [streamId]: _, ...directions }) => directions);
    }, [setStreamDirection]);
}
